var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.buyer,
        title: _vm.$t("DELETE_BUYER_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("DELETE"),
        "confirm-button-loading": _vm.loadingDeletingBuyer,
        "show-cancel-button": _vm.showActions,
        "show-confirm-button": _vm.showActions
      },
      on: { confirm: _vm.confirmDelete, close: _vm.closeDeleteModal }
    },
    [
      !_vm.buyerReferences
        ? _c(
            "div",
            [
              _vm.loadingBuyerReferences
                ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                : _vm._e(),
              _vm._v(" "),
              _c("i18n", {
                attrs: { path: _vm.checkReferencesText, tag: "span" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buyerName",
                      fn: function() {
                        return [_c("strong", [_vm._v(_vm._s(_vm.buyer.name))])]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  743059770
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.buyerReferences && !_vm.buyerReferences.hasReferences
        ? _c("i18n", {
            attrs: {
              path: "DELETE_BUYER_MODAL_NONE_ASSOCIATION_TEXT",
              tag: "p"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "buyerName",
                  fn: function() {
                    return [_c("strong", [_vm._v(_vm._s(_vm.buyer.name))])]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              743059770
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buyerReferences && _vm.buyerReferences.hasReferences
        ? _c("div", [
            _c(
              "p",
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("DELETE_BUYER_MODAL_CONFIRM_QUESTION")) +
                    "\n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("i18n", {
                  attrs: {
                    path: "DELETE_BUYER_MODAL_ASSOCIATION_TEXT",
                    tag: "span"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "buyerName",
                        fn: function() {
                          return [
                            _c("strong", [_vm._v(_vm._s(_vm.buyer.name))])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    743059770
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
              _c("div", { staticClass: "form-horizontal" }, [
                _vm.buyerReferences.ringbausers &&
                _vm.buyerReferences.ringbausers.length
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Users")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.buyerReferences.ringbausers, function(
                            user,
                            index
                          ) {
                            return _c("li", { key: index }, [
                              _c(
                                "span",
                                {
                                  staticClass: "display-text",
                                  attrs: { title: user.ringbauserName }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(user.ringbauserName) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.buyerReferences.targets &&
                _vm.buyerReferences.targets.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Targets")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.buyerReferences.targets, function(
                            target,
                            index
                          ) {
                            return _c("li", { key: index }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.right.hover",
                                      value: _vm.$t(target.targetEditTooltip),
                                      expression:
                                        "$t(target.targetEditTooltip)",
                                      modifiers: { right: true, hover: true }
                                    }
                                  ],
                                  attrs: {
                                    href: _vm.getTargetHref(target),
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "display-text",
                                      attrs: { title: target.targetName }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(target.targetName) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-external-link m-l-5"
                                  })
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }